<template>
  <div class="adminPanel">
    <p class="adminPanel__logged-as-paraghraph">
      Zalogowany/a jako <b>{{ loggedAs }}</b>
    </p>

    <div class="adminPanel__small-navigation">
      <ul>
        <li><a href="#add-dish" v-smooth-scroll>Dodaj danie</a></li>
        <li><a href="#edit-dish" v-smooth-scroll>Edytuj danie</a></li>
        <li><a href="#delete-dish" v-smooth-scroll>Usuń dane</a></li>
      </ul>
    </div>

    <dishForm id="add-dish"
              heading="Dodaj danie do menu"
              textOnButton="Dodaj"
              type="add">
    </dishForm>

    <dishForm id="edit-dish"
              heading="Edytuj danie z menu"
              textOnButton="Edytuj"
              type="edit">
    </dishForm>

    <removeDishForm></removeDishForm>

    <button class="adminPanel__logout-button"
            @click="logout">Wyloguj się</button>
  </div>
</template>

<script>
import firebase from 'firebase'
import { dishForm, removeDishForm } from '../components/adminPanel_components'

export default {
  name: 'adminPanel',
  components: { dishForm, removeDishForm },
  data () {
    return {
      loggedAs: firebase.auth().currentUser.email,
      file: ''
    }
  },
  created () {
    this.$emit('makeScrolled', true)
  },
  methods: {
    logout () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('/login')
      })
    }
  }
}
</script>
